import { PanelType } from '../../../../panels/types';

export const templatesPanelType: PanelType = {
  name: 'templates',
  location: 'left'
};
